import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuard } from './guards/auth.guard';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { ExpireComponent } from './views/error/expire.component';
import { SuccessComponent } from './views/error/success.component';
import { ForgetPasswordComponent } from './views/login/forgetPassword.component';
import { LoginComponent } from './views/login/login.component';
import { ResetPasswordComponent } from './views/login/resetPassword.component';
import { SignUpComponent } from './views/login/signup.component';
import { AddSelfGuestComponent } from './views/resident/addSelfGuest.component';
import { AddSelfCheckInComponent } from './views/resident/addSelfCheckIn.component';
import { SelfCheckInFormComponent } from './views/SelfCheckIn/selfCheckInForm.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    data: {
      title: 'Forget-password'
    }
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    data: {
      title: 'Sign up'
    }
  },
  {
    path: 'reset_password/:username/:token',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password'
    }
  },
  {
    path: 'self_service/:accountId/:uniqueCode',
    component: AddSelfGuestComponent,
    data: {
      title: 'Self Service'
    }
  },
  {
    path: 'self_check_in',
    component: SelfCheckInFormComponent,
    data: {
      title: 'Self Check In'
    }
  },
  {
    path: 'self_check_in/:deviceId',
    component: SelfCheckInFormComponent,
    data: {
      title: 'Self Check In'
    }
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'success/:id',
    component: SuccessComponent,
    data: {
      title: 'Success Page'
    }
  },
  {
    path: 'expire',
    component: ExpireComponent,
    data: {
      title: 'Success Page'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'home',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'property',
        loadChildren: () => import('./views/Account/propertyAccount.module').then(m => m.PropertyAccountModule)
      },
      {
        path: 'systemNotification',
        loadChildren: () => import('./views/Account/systemNotification.module').then(m => m.SystemNotificationModule)
      },
      {
        path: 'adminstrator',
        loadChildren: () => import('./views/Administrator/administrator.module').then(m => m.AdministratorModule)
      },
      {
        path: 'premise',
        loadChildren: () => import('./views/premise/premise.module').then(m => m.PremiseModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'report',
        loadChildren: () => import('./views/report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'staff',
        loadChildren: () => import('./views/staff/staff.module').then(m => m.StaffModule)
      },
      {
        path: 'officeStaff',
        loadChildren: () => import('./views/OfficeStaff/officeStaff.module').then(m => m.OfficeStaffModule)
      },
      {
        path: 'resident',
        loadChildren: () => import('./views/resident/resident.module').then(m => m.ResidentModule)
      },
      {
        path: 'employee',
        loadChildren: () => import('./views/employee/employee.module').then(m => m.EmployeeModule)
      },
      {
        path: 'serviceProvider',
        loadChildren: () => import('./views/ServiceProvider/serviceProvider.module').then(m => m.ServiceProviderModule)
      },
      {
        path: 'contractor',
        loadChildren: () => import('./views/ServiceProvider/serviceProvider.module').then(m => m.ServiceProviderModule)
      },
      {
        path: 'houseHelp',
        loadChildren: () => import('./views/HouseHelp/houseHelp.module').then(m => m.HouseHelpModule)
      },
      {
        path: 'flagged',
        loadChildren: () => import('./views/Flagged/flagged.module').then(m => m.FlaggedModule)
      },
      {
        path: 'blackList',
        loadChildren: () => import('./views/blackListVisitor/blacklist.module').then(m => m.BlackListModule)
      },
      {
        path: 'guest',
        loadChildren: () => import('./views/guest/guest.module').then(m => m.GuestModule)
      },
      {
        path: 'visitor',
        loadChildren: () => import('./views/guest/guest.module').then(m => m.GuestModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'rejected',
        loadChildren: () => import('./views/rejected/rejectedVisitor.module').then(m => m.RejectedVisitorModule)
      },
      {
        path: 'panicNotification',
        loadChildren: () => import('./views/panicNotifications/panicNotifications.module').then(m => m.PanicNotificationsModule)
      },
      {
        path: 'vehicle',
        loadChildren: () => import('./views/vehicleManagement/vehicle.module').then(m => m.vehicleModule)
      },
      {
        path: 'scrapAgent',
        loadChildren: () => import('./views/ScrapAgentManagement/scrapAgent.module').then(m => m.scrapAgentModule)
      }
    ]
  },
  { path: '**', component: P500Component}
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}

